import React from "react";
import { Form } from "rsuite";

const FamilyDetails = () => {
  return (
    <div className="grid grid-cols-1 mt-3 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-5">
      <Form.Group>
        <Form.ControlLabel>Father Name</Form.ControlLabel>
        <Form.Control name="FatherName" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Father Name (Nepali)</Form.ControlLabel>
        <Form.Control name="FatherName_Nepali" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Mother Name</Form.ControlLabel>
        <Form.Control name="MotherName" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Mother Name(Nepali)</Form.ControlLabel>
        <Form.Control name="MotherName_Nepali" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Grandfather Name</Form.ControlLabel>
        <Form.Control name="GrandfatherName" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Grandfather Name(Nepali)</Form.ControlLabel>
        <Form.Control name="GrandfatherName_Nepali" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Spouse Name</Form.ControlLabel>
        <Form.Control name="SpouseName" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Spouse Name(Nepali)</Form.ControlLabel>
        <Form.Control name="SpouseName_Nepali" />
      </Form.Group>
    </div>
  );
};

export default FamilyDetails;
